<template>
    <div>
        <Banner />
        <Content0 />
        <Content1 />
        <Content2 />
        <Content3 />
    </div>
</template>

<script>
import Banner from "./Banner";
import Content0 from "./Content0";
import Content1 from "./Content1";
import Content2 from "./Content2";
import Content3 from "./Content3";
import initAimation from "../animation"
export default {
    name: "Home",
    mounted(){
        setTimeout(initAimation,0)
    },
    components: {
        Banner,
        Content0,
        Content1,
        Content2,
        Content3,
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/Pages/Home/Home.vue